import { createAppStore } from '@store/createAppStore';

import { InvoicingOrder, MailModalFormTypes } from './types';

const [accountingOrder, setAccountingOrder] = createAppStore<{
  order: InvoicingOrder | null;
  emailModalFormVals: MailModalFormTypes;
  documentUrls: string[]; //These are the urls of the documents that are attached to the order and used for customer invoice generation
}>(
  {
    order: null,
    emailModalFormVals: {
      from: 'ar@armstrongtransport.com',
      to: [],
      subject: 'Armstrong Invoice # ',
      body: 'Attached is an invoice for Armstrong Transport Group. Please acknowledge you have received this invoice. If you need any other assistance, please contact Armstrong at ar@armstrongtransport.com.',
      attachmentName: '',
      documentUrl: '',
      documentExists: false,
      orderId: 0,
      isPDF: false,
      defaultEmailAccount: 'web@armstrongtransport.com',
      initialCommentCount: 0,
      approvalCommentsLength: 0,
    },
    documentUrls: [],
  },
  'accountingOrder',
);

export const updateAccountingOrderState = (
  updates: Partial<InvoicingOrder>,
) => {
  Object.entries(updates).forEach(([key, value]) => {
    setAccountingOrder('order', key as keyof InvoicingOrder, value);
  });
};

export { accountingOrder, setAccountingOrder };
